import React, { useState } from "react";
import wretch from "wretch";
import concat from "lodash/concat";
import PropTypes from "prop-types";
import CommonStoryCard from "../../molecules/common-story-card";
import { LoadMoreButton } from "../../atoms/load-more-button";
import { isDesktopSizeViewport } from "../../../utils";
import HorizontalStoryCard from "../../molecules/horizontal-story-card";
import { storyFields } from "../../../constants";
import "./load-more-stories.m.css";

const LoadMoreStories = props => {
  const propsOffset = props.offset || 20;
  const [stories, setStories] = useState([]);
  const [responseStories, setResponseStores] = useState([]);
  const [offset, setOffset] = useState(propsOffset);
  const [initialRender, setInitialRender] = useState(true);

  function loadStories() {
    const limit = 20;
    const url = `${props.baseApi}&limit=${limit}&offset=${offset}&fields=${storyFields}`;
    wretch()
      .url(url)
      .get()
      .json(results => {
        const resultsData = results && results.results ? results.results : results;
        setResponseStores(resultsData.stories || resultsData.items);
        setInitialRender(false);
        const updatedResults = concat(stories, resultsData.stories || resultsData.items);
        setStories(updatedResults);
        setOffset(offset + limit);
      });
  }
  return (
    <div>
      {stories.length > 0 &&
        stories.map(item => {
          const story = item.story ? item.story : item;
          return isDesktopSizeViewport() ? (
            <HorizontalStoryCard
              story={story}
              key={story.id}
              boxPadding={props.boxPadding || false}
              showSection={props.showSection || false}
              increaseFontSize
            />
          ) : (
            <CommonStoryCard key={story.id} story={story} showSection={props.showSection || false} />
          );
        })}
      {initialRender || (responseStories && responseStories.length > 0) ? (
        <div styleName="load-more">
          <LoadMoreButton onClick={() => loadStories()} />
        </div>
      ) : null}
    </div>
  );
};

LoadMoreStories.propTypes = {
  baseApi: PropTypes.string,
  offset: PropTypes.number,
  showSection: PropTypes.bool,
  boxPadding: PropTypes.bool
};

export default LoadMoreStories;
